import { render, staticRenderFns } from "./AcademicYearFormPage.vue?vue&type=template&id=a20a1758&scoped=true"
import script from "./AcademicYearFormPage.vue?vue&type=script&lang=js"
export * from "./AcademicYearFormPage.vue?vue&type=script&lang=js"
import style0 from "./AcademicYearFormPage.vue?vue&type=style&index=0&id=a20a1758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20a1758",
  null
  
)

export default component.exports